var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgNotebooks = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10 3.429h-.571v6.651l.937-.781.36-.3a.429.429 0 0 1 .548 0l.36.3.937.781V3.429H10ZM8.571 4v-.571H5A1.571 1.571 0 0 0 3.429 5v10A1.571 1.571 0 0 0 5 16.571h10A1.571 1.571 0 0 0 16.571 15V5A1.571 1.571 0 0 0 15 3.429h-1.571V11a.428.428 0 0 1-.244.388.49.49 0 0 1-.187.04.428.428 0 0 1-.277-.103l-.004-.004-1.35-1.13L11 9.885l-.367.307-1.35 1.13-.004.004A.43.43 0 0 1 8.57 11V4Zm12.126 2.697a.428.428 0 0 1 .732.303v10A4.429 4.429 0 0 1 17 21.429H7a.429.429 0 0 1 0-.858h10A3.571 3.571 0 0 0 20.571 17V7c0-.114.046-.223.126-.303ZM17.429 5v10A2.429 2.429 0 0 1 15 17.429H5A2.429 2.429 0 0 1 2.571 15V5A2.429 2.429 0 0 1 5 2.571h10A2.429 2.429 0 0 1 17.429 5Z",
  stroke: "currentColor",
  strokeWidth: 1.143
})));

export default SvgNotebooks;